import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";

import { useEffect, useState } from "react";
import { validate } from "components/validateGeneralForm";
import { toast } from "react-toastify";
import { erroInesperado } from "services/Utils";
import GeneralForm from "components/GeneralForm";

import logo from 'assets/img/brand/logo-estreito-claro.png'

import mapaPublicoService from "services/MapaPublicoService";
import MapaView from "components/MapaView";

export default function IncluirOSSemaforica() {
  const [cruzamentos, setCruzamentos] = useState([])
  const [cruzamentoSelecionado, setCruzamentoSelecionado] = useState(null)
  const [data, setData] = useState({})
  const [tiposProblema, setTiposProblema] = useState([])

  useEffect(() => {
    mapaPublicoService.tipoProblema().then(res => {
      if (res.success) {
        setTiposProblema(res.data)
      }
    })
  }, [])

  const formConfig = [
    [
      {
        name: "idTipoProblema",
        label: 'Descrição do Problema',
        type: "combo",
        required: true,
        colspan: 12,
        options: tiposProblema,
        optionValue: 'id',
        optionLabel: 'descricao',
        showDefault: true,
      },
    ]
  ]

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    try {
      await mapaPublicoService.incluirOcorrencia({
        idCruzamento: cruzamentoSelecionado.id,
        idTipoProblema: data.idTipoProblema,
      })
      setData({})
      setCruzamentoSelecionado(null)
      toast('Registro salvo com sucesso!')
    } catch (ex) {
      erroInesperado()
    }

  }

  const handleIdle = async (minLat, maxLat, minLng, maxLng) => {
    const res = await mapaPublicoService.cruzamentos(minLat, maxLat, minLng, maxLng)
    if (res.success)
      setCruzamentos(res.data)
  }

  return (
    <>
      <div className="main-content" style={{
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: 0,
      }}>
        <div className="header bg-white" style={{ height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={logo} alt="Logo ViaTech" style={{ height: 60 }} />
        </div>
        <div style={{ flex: 1, position: 'relative' }}>
          <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 }}>
            <MapaView
              cruzamentos={cruzamentos}
              onClick={cruzamento => setCruzamentoSelecionado(cruzamento)}
              onIdle={handleIdle}
            />
          </div>
        </div>
      </div>

      <Modal
        isOpen={!!cruzamentoSelecionado}
        toggle={() => setCruzamentoSelecionado(!cruzamentoSelecionado)}
        onClosed={() => setCruzamentoSelecionado(null)}
      >
        <ModalBody className="d-flex flex-column" style={{ rowGap: 10 }}>
          <h1>Informações do Cruzamento</h1>
          {cruzamentoSelecionado && (
            <>
              <div><strong>Cruzamento:</strong> {cruzamentoSelecionado.numero}</div>
              <div><strong>Endereço:</strong> {cruzamentoSelecionado.endereco}</div>
              {cruzamentoSelecionado.possuiOrdemServicoEmAberto && (
                <div className="alert alert-warning" role="alert">
                  <i className="bi bi-exclamation-triangle"></i> Existe atendimento em andamento neste cruzamento
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <GeneralForm
                  config={formConfig}
                  data={data}
                  onChange={handleChange}
                  disabled={false}
                />
                <Button type="submit" color="primary">Registrar problema</Button>
              </form>

            </>
          )}
        </ModalBody>
      </Modal>
    </>
  )
}